import { useState } from 'react';
import { Wordmark } from './Logo.jsx';
import { ThemeToggle } from './ThemeToggle.jsx';
import { api } from './api.js';

// Deliberately vague. "No such account" and "wrong password" must read the same to
// someone outside, or the form becomes a way to find out who holds an account.
const MESSAGES = {
  invalid_credentials: 'Those details were not recognised.',
  too_many_attempts: 'Too many attempts. Wait a few minutes and try again.',
  invalid_request: 'Fill in all three fields.',
};

export function Login({ onSignedIn }) {
  const [tenant, setTenant] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onSignedIn(await api.login(tenant.trim(), email.trim(), password));
    } catch (err) {
      setError(MESSAGES[err.code] || 'Could not sign in. Try again shortly.');
      setPassword('');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <form className="login" onSubmit={submit}>
        <div className="loginTop"><ThemeToggle /></div>
        <Wordmark size={44} />
        <p className="sub">INCIDENT COMMAND</p>

        <div className="field">
          <label htmlFor="tenant">Organisation</label>
          <input id="tenant" value={tenant} onChange={(e) => setTenant(e.target.value)}
                 autoComplete="organization" autoCapitalize="none" spellCheck="false" required />
        </div>
        <div className="field">
          <label htmlFor="email">Email</label>
          <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                 autoComplete="username" autoCapitalize="none" spellCheck="false" required />
        </div>
        <div className="field">
          <label htmlFor="password">Password</label>
          <input id="password" type="password" value={password}
                 onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
        </div>

        <button className="btn" type="submit" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>

        {error && <p className="err" role="alert">{error}</p>}
        <p className="foot">Access is logged.</p>
      </form>
    </div>
  );
}
